import axios from 'axios';
import { ApiEndpoints } from './urls';

// Build just the optional drill-down filters (record_type / error_type) the
// status API understands. Empty/None values are left off so the backend
// treats them as "no filter".
const filterParams = ({ recordType = null, errorType = null } = {}) => {
  const params = {};
  if (recordType) {
    params.record_type = recordType;
  }
  if (errorType) {
    params.error_type = errorType;
  }
  return params;
};

class OptimiserStatusApi {
  // Grouped failure counts by (record_type, error_type) for the caller's tenancy.
  static getSummary() {
    return axios.get(ApiEndpoints.optimiserStatusSummary);
  }

  // Paginated, filterable drill-down of individual violations. The backend uses
  // limit/offset (LimitOffsetPagination), so we translate page/pageSize here.
  static getViolations(props = {}) {
    const { page = 0, pageSize = 50, sort = {} } = props;
    const params = {
      limit: pageSize,
      offset: page * pageSize,
      ...filterParams(props)
    };
    if (sort && sort.field) {
      params.ordering = sort.order === 'descend' ? `-${sort.field}` : sort.field;
    }
    return axios.get(ApiEndpoints.optimiserStatusViolations, { params });
  }

  // CSV of the (optionally filtered) failure list. Returned as a blob so the
  // caller can trigger a browser download.
  static getExport(props = {}) {
    return axios.get(ApiEndpoints.optimiserStatusExport, {
      params: filterParams(props),
      responseType: 'blob'
    });
  }

  // Global Solace broker health for the top-menu indicator.
  static getBrokerHealth() {
    return axios.get(ApiEndpoints.optimiserBrokerHealth);
  }

  // Global Optimiser run status for the top-menu run indicator.
  static getRunStatus() {
    return axios.get(ApiEndpoints.optimiserRunStatus);
  }

  static getPublishAttempts() {
    return axios.get(ApiEndpoints.optimiserStatusPublishAttempts);
  }

  // Latest 5 completed/failed run-status messages for the caller's tenancy.
  static getRunHistory() {
    return axios.get(ApiEndpoints.optimiserStatusRunHistory);
  }

  // Latest 5 optimiser write-back messages (assignments received back) for the
  // caller's tenancy — status page tile + "Roster updates" section.
  static getWritebackHistory() {
    return axios.get(ApiEndpoints.optimiserStatusWritebackHistory);
  }

  static retryPublish(id) {
    return axios.post(ApiEndpoints.optimiserStatusRetry.replace(':id:', id));
  }

  // One page of the records a publish attempt sent (summary + body each).
  static getAttemptRecords(id, { limit = 50, offset = 0 } = {}) {
    return axios.get(ApiEndpoints.optimiserStatusAttemptRecords.replace(':id:', id), { params: { limit, offset } });
  }
}

export { filterParams };
export default OptimiserStatusApi;
